import React from 'react';
import Popup from 'react-popup';
import './DynamicLinkTable.component.css';
import '../Popup.component.css'

import DynamicLinkRow from './dynamic-link-row/DynamicLinkRow.component';
import DynamicTableButtons from './dynamic-table-buttons/DynamicTableButtons.component';

export default class DynamicLinkTable extends React.Component {

    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleClear = this.handleClear.bind(this);

        this.shouldShowHeader = this.shouldShowHeader.bind(this);
        this.shouldShowReferenceNumberHeader = this.shouldShowReferenceNumberHeader.bind(this);
        this.shouldShowPreloadEquipmentDecalHeader = this.shouldShowPreloadEquipmentDecalHeader.bind(this);
        this.appointmentErrorDisplayed = false;
    }

    async handleSubmit() {
        await this.props.onSubmit();
    }

    handleClear() {
        Popup.create({
            title: 'Please Confirm',
            content: 'This will clear all of your selections. Are you sure you want to do this?',
            buttons: {
                right: [{
                    text: "Cancel",
                    action: function () {
                        /** Close this popup. Close will always close the current visible one, if one is visible */
                        Popup.close();
                    },
                },
                {
                    text: "Clear",
                    action: function () {
                        /** Close this popup. Close will always close the current visible one, if one is visible */
                        Popup.close();
                        this.props.onClear();

                        this.setState({
                            confirmAll: false
                        });
                    }.bind(this),
                }]
            }
        });
    }

    shouldShowHeader(header) {
        if (header.isSpecialColumn) {
            switch (header.displayName) {
                case 'Confirm':
                case 'Appt Start - End': return true;
                case 'Appt Reference Number': return this.shouldShowReferenceNumberHeader();
                case 'Preloaded Equipment Decal ID': return this.shouldShowPreloadEquipmentDecalHeader();
                default: break;
            }
        }
        return true;
    }

    shouldShowReferenceNumberHeader() {
        return this.props.orderList.some((order) => order.showAppointmentReferenceNumber);
    }

    shouldShowPreloadEquipmentDecalHeader() {
        return this.props.orderList.some((order) => order.showPreloadedEquipmentDecal);
    }

    renderConfirmAllButton() {
        if (this.props.orderList.length > 0) {
            return (
                <input
                    type="button"
                    value="Select All"
                    className="confirm-all-button"
                    onClick={this.props.onConfirmAll}
                    disabled={this.props.isSubmitting} />
            );
        }
    }

    renderTableHeader() {
        return (
            <tr>
                {
                    this.props
                        .headers
                        .filter((h) => this.shouldShowHeader(h))
                        .map((h) => <th>{h.displayName}</th>)
                }
            </tr>
        );
    }

    renderTableRows() {
        return this.props.orderList.map((value, index) => {
            return <DynamicLinkRow
                order={value}
                headers={this.props.headers}
                isSubmitting={this.props.isSubmitting}
                onOrderChange={this.props.onOrderChange.bind(this, index)} />
        });
    }

    renderNoRowMessage() {
        if (this.props.orderList.length === 0) {
            var message = "";
            if (this.props.appointmentErrors.length === 0) {
                message = "Thank You! All appointments associated with this link have been confirmed.";
            } else {
                message = "An error has occurred, please reply to the email to confirm appointments";
            }
            return (
                <div className="no-row-message-container">
                    {message}
                </div>
            );
        }
    }

    renderFormButtons() {
        if (this.props.orderList.length > 0) {
            return (
                <DynamicTableButtons
                    orderList={this.props.orderList}
                    isSubmitting={this.props.isSubmitting}
                    onSubmit={this.handleSubmit}
                    onClear={this.handleClear} />
            );
        }
    }

    render() {
        if (this.props.appointmentErrors.length > 0 && !this.appointmentErrorDisplayed) {
            var failedOrderIds = this.props.appointmentErrors.map(appointmentError => appointmentError.orderId).join(",");
            var errorMessage = "An error occurred while loading the following order Ids:\n" + failedOrderIds
                + "\nPlease reply to the email to confirm these appointments";
            Popup.create({
                title: 'Unknown error occurred',
                content: errorMessage,
                buttons: {
                    right: [{
                        text: "Ok",
                        action: function () {
                            Popup.close();
                        },
                    }]
                }
            });
            this.appointmentErrorDisplayed = true;
        }
        return (
            <div>
                {this.renderConfirmAllButton()}
                <div align="center">
                    <form method="POST" action="#" encType="application/json">
                        <table className="dynamic-link-table" summary="appointment-setting-table">
                            <thead>
                                {this.renderTableHeader()}
                            </thead>
                            <tbody>
                                {this.renderTableRows()}
                            </tbody>
                        </table>
                    </form>

                    {this.renderNoRowMessage()}

                    {this.renderFormButtons()}
                </div>
            </div>
        );
    }
}